// import { canUseDOM } from 'exenv';

export function innovationByDesignLoading(resp = {}, store = {}) {
  return {
    type: 'INNOVATION_BY_DESIGN_LOADING',
    innovationByDesign: resp,
    store
  };
}

export function innovationByDesignLoaded(resp = {}, store = {}, year) {
  return {
    type: 'INNOVATION_BY_DESIGN_LOADED',
    innovationByDesign: resp,
    store,
    year
  };
}

export function innovationByDesignLoadError(error, store = {}) {
  return {
    type: 'INNOVATION_BY_DESIGN_ERROR',
    innovationByDesign: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
